export default __webpack_public_path__ + "static/media/7.50e10d1f.svg";